import { render, staticRenderFns } from "./MedHxTab.vue?vue&type=template&id=00e05f43&scoped=true"
import script from "./MedHxTab.vue?vue&type=script&lang=js"
export * from "./MedHxTab.vue?vue&type=script&lang=js"
import style0 from "./MedHxTab.vue?vue&type=style&index=0&id=00e05f43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e05f43",
  null
  
)

export default component.exports